import GeneralHeader from 'components/common/GeneralHeader';
import MainHistory from 'components/common/view/employee_history/MainHistory';
import StaffLeaveAbsenceHistory from 'components/common/view/employee_history/StaffLeaveAbsenceHistory';
import StaffLeavebalanceHistory from 'components/common/view/employee_history/StaffLeavebalanceHistory';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';

const EmployeeHistory = () => {
  const [tab, setTab] = useState(0);
  const location = useLocation();
  const id = location.state;

  return (
    <GeneralHeader
      pageTitle={tab === 0 ? "Employee History" : (tab === 1 ? 'Staff Leave Absence History' : 'Staff Leave Balance History')}
      icon="/icons/general_setting.svg"
      child={
        <div style={{ marginTop: '6rem' }} className="history_page">
          <div
            className="is-flex is-justify-content-space-between"
            style={{ width: '50%', whiteSpace: 'nowrap', gap: '30px' }}
          >
            {[
              'Employee History',
              'Staff Leave Absence History',
              'Staff Leave Balance History',
            ].map((item, index) => (
              <h1
                key={index}
                className={`tab-title is-clickable ${tab === index && 'tab-active'
                  }`}
                onClick={() => setTab(index)}
              >
                {item}
              </h1>
            ))}
          </div>
          {
            {
              0: <MainHistory id={id} />,
              1: <StaffLeaveAbsenceHistory id={id} />,
              2: <StaffLeavebalanceHistory id={id} />,
            }[tab]
          }
        </div>
      }
    />
  );
};

export default EmployeeHistory;
